<template>
  <div>
    <record v-if="profile" :record="profile" file-type="customers" />
    <loading-spinner v-else />
  </div>
</template>

<script>
  import InsightsComputationMixin from '../Insights/InsightsComputationMixin';
  import LoadingSpinner from '../LoadingSpinner';
  import axios from 'axios';
  import {fullURL} from '../../utils';
  import Record from './Record';

  export default {
    name: 'CustomerDetails',

    components: {
      LoadingSpinner,
      Record
    },

    mixins: [
      InsightsComputationMixin,
    ],

    data() {
      return {
        profile: null
      };
    },

    methods: {
      resetInsightsData() {
        this.profile = null;
      },

      computeInsightsData() {
        axios.get(fullURL(`/360-view/${this.nameS}/${this.filter}`))
          .then(({data}) => {
            this.profile = data;
          })
          .catch(console.log);
      }
    },
  };
</script>

<style scoped>

</style>
